@if (scrim) {
  <div class="chart-overlay-scrim"></div>
}
<div class="chart-overlay-text">
  <mat-icon>{{ icon }}</mat-icon>
  <span>{{ message }}</span>
  @if (ctaLabel && ctaRouterLink) {
    <a class="chart-overlay-cta" [routerLink]="ctaRouterLink">{{ ctaLabel }}</a>
  } @else if (ctaLabel && ctaHref) {
    <a class="chart-overlay-cta" [href]="ctaHref" target="_blank" rel="noopener noreferrer">{{ ctaLabel }}</a>
  }
</div>
